/**
 * QA Panel — runtime constants.
 */

/** localStorage key checked at boot to auto-open the panel. */
export const ACTIVATION_STORAGE_KEY = 'qa-panel-enabled';

/** URL query param checked at boot to auto-open the panel. */
export const ACTIVATION_URL_PARAM = 'qa';

/** Keyboard shortcut: Ctrl+Shift+Q (or Cmd+Shift+Q on macOS). */
export const ACTIVATION_KEY = 'Q';
export const ACTIVATION_KEY_BG = 'Я';
export const ACTIVATION_KEYS = [ACTIVATION_KEY, ACTIVATION_KEY_BG];

/** window.open name and feature string. */
export const POPUP_WINDOW_NAME = 'react-lobby-qa-panel';
export const POPUP_FEATURES = 'width=950,height=920,resizable=yes,scrollbars=yes,location=no,menubar=no,toolbar=no,status=no';

/**
 * Duration (ms) of the StatusBar settings-button hold that opens the in-DOM
 * overlay on touch devices. Long enough that a real "open settings" tap never
 * triggers it by accident.
 */
export const LONG_PRESS_DURATION_MS = 5000;

/**
 * Pointer travel (px) past which an in-progress long-press is treated as a
 * scroll/drag and cancelled.
 */
export const LONG_PRESS_MOVE_THRESHOLD_PX = 10;

/** Reference language used as the source of truth for coverage diffs. */
export const REFERENCE_LANGUAGE = 'en';

/**
 * postMessage origin for popup-to-lobby and lobby-to-popup messages.
 *
 * The popup is opened with about:blank, so its origin is null. Use '*' for
 * both directions; we authenticate messages by their typed structure, not
 * by origin. This is a dev-only tool — never enabled in production builds.
 */
export const MESSAGE_TARGET_ORIGIN = '*';

/**
 * Identifier embedded in every message so the bridge can ignore unrelated
 * postMessage traffic (the lobby talks to the Game Client over postMessage too).
 */
export const MESSAGE_NAMESPACE = 'react-lobby-qa-panel';
